import type { BrandPresetId } from '@workspace/types';
import { BRAND_PRESETS } from '../../themes/presets';
import { useBrandTheme } from '../providers/brand-theme-provider.utils';
import { cn } from '../../lib/utils';
import { toast } from 'react-toastify';

const PRESET_OPTIONS: BrandPresetId[] = ['setup', 'microsyst'];

export function BrandPresetSelector({ className }: { className?: string }) {
  const { presetId, saving, setBrandPreset } = useBrandTheme();

  const handleSelect = async (option: BrandPresetId) => {
    if (option === presetId || saving) {
      return;
    }

    try {
      await setBrandPreset(option);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'No se pudo cambiar la marca');
    }
  };

  return (
    <div
      className={cn('flex items-center gap-1 rounded-lg border border-border bg-muted p-1', className)}
      aria-label='Seleccionar marca de la instalación'
      aria-busy={saving}
    >
      {PRESET_OPTIONS.map(option => {
        const label = BRAND_PRESETS[option].name;
        const active = presetId === option;
        return (
          <button
            key={option}
            type='button'
            disabled={saving}
            onClick={() => {
              void handleSelect(option);
            }}
            className={cn(
              'px-2.5 py-1 rounded-md text-xs font-medium transition-all',
              active
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
            aria-pressed={active}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
